<template>
  <div v-show="isVisible" class="modal-overlay flex" @click.self="close">
    <div class="modal-content flex">
      <!-- <button class="close-btn" @click="close">×</button> -->
      <span class="material-symbols-rounded close-btn" @click="close"
        >close</span
      >
      <div class="modal-header flex">
        <span class="material-symbols-rounded">error</span>
        <span class="header-title">שימו לב</span>
      </div>
      <div class="modal-body">
        <p class="main-text">
          אם נתקלתם בחוסר או במוצר פגום,
          <br />
          סכום הזיכוי יוחזר לאמצעי התשלום שלכם (למעט זיכויי קופה) עד 14 ימי
          עסקים או ימומש בקנייה הבאה, המוקדם מביניהם.
        </p>
        <div class="modal-header d-block !p-0 m-auto mt-3 mb-2 text-center">
          <span class="header-title">הכסף נשאר אצלכם בארנק</span>
        </div>
        <p class="bold-text">
          מעדיפים להשאיר את הכסף שלכם במשנת יוסף ולחסוך בלגן?
        </p>
        <div class="checkbox-row flex">
          <input type="checkbox" id="keepRefund" v-model="keepRefund" />
          <label for="keepRefund"
            >כן, תשאירו את הזיכויים בחשבון שלנו במשנת יוסף</label
          >
        </div>
        <p class="small-gray-text">תמיד אפשר לשנות את הבחירה באזור המשפחתי</p>
      </div>
      <div class="modal-footer flex">
        <button class="continue-btn" @click="saveAndContinue">
          להמשיך בקנייה
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import axiosInstance from "../../helpers/axios.js";

const keepRefund = ref(false);
const isVisible = ref(true);

const store = useStore();

async function close() {
  exit();

  await axiosInstance.post("/profile/refund_to_card_to_log/0");
  store.commit(
    "user/setRefundToCardNoSetCount",
    store.state.user.refundToCardNoSetCount + 1
  );
}

function exit() {
  isVisible.value = false;
}

async function saveAndContinue() {
  const refundToCard = !keepRefund.value;
  await axiosInstance.post(
    `/profile/update_refund_to_Card/${refundToCard ? 1 : 0}`
  );
  store.commit("user/setRefundToCard", refundToCard);

  exit();
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  border-radius: 5px;
  width: 100%;
  max-width: 530px;
  position: relative;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.close-btn {
  position: absolute;
  top: 10px;
  left: 16px;
}
.modal-header {
  align-items: center;
  gap: 8px;
  padding: 50px 24px 20px 24px;
  color: rgb(236 62 69);
  font-size: 18px;
}
.header-title {
  font-weight: bold;
}
.modal-body {
  padding: 0 24px 24px 24px;
}
.main-text {
  color: #222;
  font-size: 15px;
  line-height: 1.5;
}
.bold-text {
  font-weight: bold;
  color: #222;
  margin-bottom: 16px;
  font-size: 16px;
}
.checkbox-row {
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  justify-content: center;
}
.checkbox-row input {
  zoom: 1.5;
  accent-color: rgb(41 30 109 / var(--tw-bg-opacity));
}
.checkbox-row label {
  font-size: 15px;
  color: #222;
  cursor: pointer;
}
.small-gray-text {
  color: #888;
  font-size: 13px;
  margin-bottom: 8px;
}
.modal-footer {
  border-top: 1px solid #eee;
  padding: 16px 24px;
  justify-content: flex-end;
  width: 100%;
}
.continue-btn {
  background: rgb(41 30 109 / var(--tw-bg-opacity));
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 16px;
  cursor: pointer;
}
</style>